import type { ReactNode } from "react";

export function EmptyState({
  icon,
  primary,
  secondary,
}: {
  icon: ReactNode;
  primary: string;
  secondary?: string;
}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "var(--chat-space-3)",
        flex: 1,
        padding: "var(--chat-space-6)",
        textAlign: "center",
      }}
    >
      {icon}
      <p
        style={{
          color: "var(--chat-fg-primary)",
          fontFamily: "var(--chat-font-display)",
          fontSize: "var(--chat-type-display-sm-size)",
          lineHeight: "var(--chat-type-display-sm-line)",
          fontWeight: 300,
          margin: 0,
        }}
      >
        {primary}
      </p>
      {secondary && (
        <p
          style={{
            color: "var(--chat-fg-secondary)",
            fontFamily: "var(--chat-font-sans)",
            fontSize: "var(--chat-type-body-md-size)",
            lineHeight: "var(--chat-type-body-md-line)",
            margin: 0,
            maxWidth: 320,
          }}
        >
          {secondary}
        </p>
      )}
    </div>
  );
}
